import initBogoAtcModal from "components/jiffy/bogo-atc-modal/bogo-atc-modal";

document.addEventListener("DOMContentLoaded", () => {
  initBogoAtcModal();
});
